<template>
  <component
    :is="Resolved"
    v-if="Resolved"
  />
  <div
    v-else
    class="text-center my-3"
  >
    <b-spinner variant="primary" />
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

/**
 * Kvota taqsimoti sahifasi rolga qarab uch xil komponentdan biri bilan chiziladi.
 *
 * Muhim: rol tanlovi shu yerda - komponent chizilayotgan paytda - bajariladi.
 * Avval bu tanlov marshrut faylida modul yuklanish paytida bajarilardi, o'shanda esa
 * foydalanuvchi hali yuklanmagan bo'lib, marshrut umuman ro'yxatdan o'tmay qolardi.
 */
const COMPONENTS = {
  list: {
    finance: () => import('@/views/pages/quote-distribution/QuoteDistribution.vue'),
    innovation: () => import('@/views/pages/quote-distribution-innovation/QuoteDistribution.vue'),
    otm: () => import('@/views/pages/quote-distribution-otm/QuoteDistribution.vue'),
  },
  detail: {
    finance: () => import('@/views/pages/quote-distribution/View.vue'),
    innovation: () => import('@/views/pages/quote-distribution-innovation/View.vue'),
    otm: () => import('@/views/pages/quote-distribution-otm/View.vue'),
  },
  // `quote-distribution/:id` ning ota komponenti: OTM da xatni oldindan yuklaydigan
  // Get.vue kerak, qolgan rollarda esa oddiy o'tkazgich yetarli.
  wrapper: {
    otm: () => import('@/views/pages/quote-distribution-otm/Get.vue'),
    finance: () => import('@/views/pages/quote-distribution/PassThrough.vue'),
    innovation: () => import('@/views/pages/quote-distribution/PassThrough.vue'),
  },
}

const FALLBACK = () => import('@/views/SecondPage.vue')

export default {
  name: 'QuoteDistributionRouter',
  components: {
    BSpinner,
  },
  props: {
    variant: {
      type: String,
      required: true,
      validator: value => Object.keys(COMPONENTS).includes(value),
    },
  },
  data() {
    return {
      Resolved: null,
      resolveToken: 0,
    }
  },
  watch: {
    // Bir xil komponent ro'yxat ham, `:id` ham marshrutida ishlatilgani uchun
    // Vue o'tishda nusxani qayta ishlatadi va `created` boshqa chaqirilmaydi.
    // Shuning uchun komponent `variant` o'zgarishiga qarab qayta tanlanadi -
    // aks holda ro'yxatdan detailga o'tganda ekranda ro'yxat qolib ketadi.
    variant: {
      immediate: true,
      handler() {
        this.resolveComponent()
      },
    },
  },
  methods: {
    async resolveComponent() {
      this.resolveToken += 1
      const token = this.resolveToken

      if (this.$store.getters['auth/isAuthenticated'] && !this.$store.state.auth.user) {
        try {
          await this.$store.dispatch('auth/fetchUser')
        } catch (e) {
          // foydalanuvchini olishning iloji bo'lmasa, quyida fallback chiziladi
        }
        if (token !== this.resolveToken) return
      }

      // Eski komponentni oldin butunlay yo'q qilamiz, keyin yangisini chizamiz.
      // Sabab: ro'yxat va detail sahifalari bitta Vuex modulini ('quoteDistribution')
      // o'zi register/unregister qiladi. Vue esa odatda yangi komponentni eskisidan
      // OLDIN yaratadi - o'shanda yangisi "modul bor" deb ro'yxatdan o'tkazmaydi,
      // keyin eskisi o'chirilib, modul yo'qoladi va ro'yxat abadiy yuklanib qoladi.
      if (this.Resolved) {
        this.Resolved = null
        await this.$nextTick()
        if (token !== this.resolveToken) return
      }

      this.Resolved = COMPONENTS[this.variant][this.roleKey()] ?? FALLBACK
    },
    roleKey() {
      const { staticModule } = this.$store.state
      const roleId = this.$store.state.auth.user?.role_id ?? null
      if (roleId === staticModule.roleFinance) return 'finance'
      if (roleId === staticModule.roleInnovation) return 'innovation'
      if (roleId === staticModule.roleAntiCorruption) return 'innovation'
      if (roleId === staticModule.roleUniversity) return 'otm'
      return null
    },
  },
}
</script>
